import { CookieService } from "ngx-cookie-service";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { BroadcastService, MsalService } from "@azure/msal-angular";
import { CryptoUtils, Logger } from "msal";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {

  public API_URI = {
    getMemberDetails: "/Member/",
    userLastLogin: "/client/LastLoggedin",
  };

  private userInformationSubject = new BehaviorSubject<any>(null);
  userInformation$ = this.userInformationSubject.asObservable();

  constructor(
    private cookieService: CookieService,
    private apiService: ApiService,
    private broadcastService: BroadcastService,
    private authMsalService: MsalService
  ) { }

  login() {
    this.authMsalService.loginRedirect();
  }

  logout() {
    this.authMsalService.logout();
  }

  getEncodeUrl(url: any) {
    return encodeURIComponent(url);
  }

  isUserLoggedIn(): boolean {
    return !!this.authMsalService.getAccount();
  }

  getAccountInfo() {
    return this.authMsalService.getAccount();
  }

  getUserInformation() {
    return JSON.parse(window.localStorage.getItem("agentBasicDetails"));
  }

  getMemberDetails(memberId: any) {
    return this.apiService.get(this.API_URI.getMemberDetails + memberId);
  }

  updateUserLastLoggedIn() {
    return this.apiService.post(this.API_URI.userLastLogin);
  }

  getMemberID() {
    return window.localStorage.getItem('MemberID');
  }

  setMemnerID(memberID) {
    window.localStorage.setItem("MemberID", memberID);
  }

  getLocalStorageData(forWhat: any, fieldName: any = "") {
    if (!fieldName) {
      return JSON.parse(window.localStorage.getItem("" + forWhat + ""));
    } else {
      return JSON.parse(window.localStorage.getItem("" + forWhat + ""))[
        "" + fieldName + ""
      ];
    }
  }

  isAdmin(): boolean {
    return (
      this.getUserInformation()["EmailAddress"].includes("@crs.com") ||
      this.getUserInformation()["MemberType"] == "admin"
    );
  }

  initializeMsalService(): any {
    this.broadcastService.subscribe('msal:loginSuccess', (success) => {
      this.setMemnerID(success.idTokenClaims.extension_MemberID);
    });

    this.authMsalService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }
      this.setMemnerID(response.idTokenClaims.extension_MemberID);
    });

    this.authMsalService.setLogger(new Logger((logLevel, message, piiEnabled) => {
      console.log('MSAL Logging: ', message);
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));
  }

  setUserInformation(details: any) {
    window.localStorage.setItem("agentBasicDetails", JSON.stringify(details));
    this.userInformationSubject.next(details);
  }
}